import { createFileRoute } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData } from "~/app/api/pageData";
import { homePageQueryOptions } from "~/app/api/pageData/homePageQuery";
import { setRedirectState } from "~/utils/redirectionUtil";

function HomePageRoute() {
  return null;
}

export async function loadHomePageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(homePageQueryOptions());
  const pageData = unwrapPageInitialData(result);

  setRedirectState(pageData.data?.suggestUserSwitch ?? false, pageData.data?.redirectProduct ?? null);

  return pageData;
}

export const Route = createFileRoute("/")({
  loader: async ({ context }) => loadHomePageData(context),
  component: HomePageRoute,
});
